import { call, put, takeEvery } from "redux-saga/effects";
import { phongBanApi } from "../../../api/category/phongBanApi";
import { IPhongBan } from "../../../model/respone/category/IPhongBan";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  ePhongBanActionIds,
  IPhongBanActionTypes,
} from "../../action-types/category/IPhongBanActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.phongBan;

export function* phongBanSaga(): any {
  yield takeEvery(ePhongBanActionIds.LOAD_START, loadWorker);
  yield takeEvery(ePhongBanActionIds.SAVE_START, saveWorker);
  yield takeEvery(ePhongBanActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(phongBanApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
function* saveWorker(action: IPhongBanActionTypes): any {
  const payload = action.payload as IPhongBan;
  const res: IBaseRespone = payload.id > 0
    ? yield call(phongBanApi.Update, payload)
    : yield call(phongBanApi.Insert, payload);
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
}
function* deleteWorker(action: IPhongBanActionTypes): any {
  const res: IBaseRespone = yield call(phongBanApi.Delete, action.payload as number);
  if (res.is_success) yield put(mainAction.DELETE_SUCCESS(res.data));
  else yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
}
